import React, { useCallback, useState } from "react";
import { Button, InputAdornment, Typography, Pagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
/* 
  TODO -> Todo o código comentado será utilizado futuramente
*/
import {
  // FilterList as FilterListIcon,
  Search as SearchIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";

import manWomanBoxes from "assets/supergasbras/images/manWomanBoxes.svg";
import { CardPageHeader } from "ctech-react-components";
import Input from "components/Input";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleGetDealerCareRequest } from "store/modules/DealerCare/thunk.store";
import * as Styled from "./styles";

interface SearchDealerData {
  name?: string;
}

const ManageDealers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
    getValues,
  } = useForm<SearchDealerData>();

  const [page, setPage] = useState(1);
  const [limit] = useState(3);

  const dispatch = useAppDispatch();
  const {
    dealerCare: { data, pagination },
  } = useAppSelector((state) => state);

  const searchDealers: SubmitHandler<
    SearchDealerData & { pageCurrent: number }
  > = useCallback(
    ({ name, pageCurrent }) => {
      dispatch(
        handleGetDealerCareRequest({
          limit,
          offset: (pageCurrent - 1) * limit,
          term: name,
        }),
      );
    },
    [dispatch, limit],
  );

  const searchDealersSubmit: SubmitHandler<SearchDealerData> = useCallback(
    ({ name }) => {
      setPage(1);
      searchDealers({ name, pageCurrent: 1 });
    },
    [searchDealers],
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    searchDealers({
      name: getValues()?.name || "",
      pageCurrent: newPage,
    });
  };

  const navigateToDealerById = (id: string) => navigate(`/dealers/${id}`);

  return (
    <Styled.Container>
      <Styled.Content>
        <CardPageHeader
          urlImage={manWomanBoxes}
          title={<Typography variant="h5">{t("manageDealers")}</Typography>}
        />
        <Styled.Form onSubmit={handleSubmit(searchDealersSubmit)}>
          <Styled.Row>
            <Input
              name="name"
              label={t("findAReseller")}
              placeholder="Total"
              fullWidth
              sx={{ mb: 2, mr: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              error={errors.name}
              register={register}
            />
            <Styled.ActionsContainer>
              <Button variant="contained" type="submit">
                {t("search")}
              </Button>
              {/* <Button
                variant="text"
                startIcon={<FilterListIcon />}
                sx={{ ":hover": { backgroundColor: "#fff" } }}
              >
                {t("filter")}
              </Button> */}
            </Styled.ActionsContainer>
          </Styled.Row>
          {!!data?.length && (
            <>
              <Styled.Row>
                <Typography
                  variant="h6"
                  textAlign="center"
                  sx={{ mb: 3, mt: 1 }}
                >
                  {t("searchResultFor", { value: watch().name })}
                </Typography>
              </Styled.Row>
              <Styled.Row>
                <Styled.Column>
                  {data?.map(({ id, tradeName, enabled }) => (
                    <Styled.Card sx={{ mb: 2 }} key={id}>
                      <Styled.CardContentData
                        color={enabled ? undefined : "disabled"}
                      >
                        <Typography variant="h6" component="div">
                          {tradeName}
                        </Typography>
                        <Typography>
                          {!enabled && t("suspendedProfile")}
                          {/* <Styled.ContentOrders>
                            <Styled.NumberNewOrders>
                              {t("newOrders", { value: 0 })}
                            </Styled.NumberNewOrders>
                            <Styled.NumberProgressOrders>
                              {t("ordersInProgress", { value: 0 })}
                            </Styled.NumberProgressOrders>
                          </Styled.ContentOrders> */}
                        </Typography>
                      </Styled.CardContentData>
                      <Styled.CardContentActions>
                        {/* <Styled.ContainerStatus
                          colorTheme={enabled ? "success" : "error"}
                        >
                          <Typography variant="caption">
                            {t(enabled ? "openDealers" : "closedDealers")}
                          </Typography>
                        </Styled.ContainerStatus> */}
                        <Styled.ButtonAction
                          variant="text"
                          endIcon={<OpenInNewIcon />}
                          sx={{ ml: 1.5 }}
                          onClick={() => navigateToDealerById(id)}
                        >
                          {t("open")}
                        </Styled.ButtonAction>
                      </Styled.CardContentActions>
                    </Styled.Card>
                  ))}
                </Styled.Column>
              </Styled.Row>
              <Styled.Row>
                <Styled.ContentPagination>
                  <Pagination
                    count={Math.ceil(pagination.totalCount / limit)}
                    page={page}
                    onChange={handleChangePage}
                  />
                </Styled.ContentPagination>
              </Styled.Row>
            </>
          )}
        </Styled.Form>
      </Styled.Content>
    </Styled.Container>
  );
};

export default ManageDealers;
